import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/brand/logo_default.png'
import _imports_1 from '../assets/brand/logo_white.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  style: {"height":"35px"}
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "logo dark-themed",
  src: _imports_1,
  style: {"height":"35px"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Mein Account ")

import { computed } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()

const store = useStore()

const user = computed(() => route.params.user)

const theme = computed(() => store.state.theme)

function toggleTheme() {
  const theme = store.state.theme === 'default' ? 'dark' : 'default'
  store.commit({
    type: 'toggleTheme',
    value: theme,
  })
}

return (_ctx: any,_cache: any) => {
  const _component_CNavLink = _resolveComponent("CNavLink")!
  const _component_CHeaderBrand = _resolveComponent("CHeaderBrand")!
  const _component_CNavItem = _resolveComponent("CNavItem")!
  const _component_CHeaderNav = _resolveComponent("CHeaderNav")!
  const _component_CIcon = _resolveComponent("CIcon")!
  const _component_CButton = _resolveComponent("CButton")!
  const _component_CContainer = _resolveComponent("CContainer")!
  const _component_CHeader = _resolveComponent("CHeader")!

  return (_openBlock(), _createBlock(_component_CHeader, {
    position: "sticky",
    class: "mb-4"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_CContainer, { fluid: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_CHeaderBrand, null, {
            default: _withCtx(() => [
              _createVNode(_component_CNavLink, {
                href: `/dashboard/${_unref(user)}/`
              }, {
                default: _withCtx(() => [
                  _hoisted_1,
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["href"])
            ]),
            _: 1
          }),
          _createVNode(_component_CHeaderNav, { class: "d-flex me-auto pt-lg-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_CNavItem, null, {
                default: _withCtx(() => [
                  _createVNode(_component_CNavLink, { href: "/my-account/devices/" }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_CHeaderNav, null, {
            default: _withCtx(() => [
              (_unref(theme) === 'dark')
                ? (_openBlock(), _createBlock(_component_CButton, {
                    key: 0,
                    color: "dark",
                    size: "sm",
                    onClick: toggleTheme
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CIcon, { icon: "cil-sun" })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_CButton, {
                    key: 1,
                    color: "light",
                    size: "sm",
                    onClick: toggleTheme
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CIcon, { icon: "cil-moon" })
                    ]),
                    _: 1
                  }))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})